import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getEscolaridades } from "../../Services/escolaridad_service";

const initialState = {
    escolaridades: [],
    escolaridadSeleccionada: null,
}

export const escolaridadesSlice = createSlice({
    name: 'escolaridad',
    initialState,
    reducers: {
        setEscolaridades: (state, action) => {
            state.escolaridades = action.payload;
        },
        setEscolaridadSeleccionada: (state, action) => {
            state.escolaridadSeleccionada = action.payload;
        }
    }
});

export const fetchEscolaridades = createAsyncThunk(
    'escolaridad/fetchEscolaridades',
    async (_, { dispatch }) => {
        const escolaridades = await getEscolaridades();
        dispatch(setEscolaridades(escolaridades));
    }
);

export const { setEscolaridades, setEscolaridadSeleccionada } = escolaridadesSlice.actions;
export default escolaridadesSlice.reducer;